module.exports = __webpack_public_path__ + "static/media/checkmark-light.e983d5ef.svg";